//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HeadBar from './component/bar/headBar';
import FootBar from './component/bar/footBar';
import { mapGetters } from 'vuex';

export default {
    name: 'app',
    components: { HeadBar, FootBar },
    data() {
        return {
            tabs: null,
            isCn: this.$x.userInfo.lgid === 2052,
            isKayangIos: self.webkit && !!self.webkit.messageHandlers, //是否嘉扬ios的app
        }
    },
    created() {
    },
    methods: {},
    watch: {
        routerTabs(n, o) {
            this.tabs = n;
            if (!n.length) {
                this.$router.replace('/errorMsg')
            }
        },
        //目前只有报表最大化横屏显示
        fullScreen(n, o) {
            const body = this.$x('body')[0];
            const bodyWidth = body.offsetWidth;
            const bodyHeight = body.offsetHeight;
            const full = this.$x('.full')[0];
            if (full) {
                if (n) {
                    full.style.width = bodyHeight + 'px';
                    full.style.height = bodyWidth + 'px';
                    full.style.top = (bodyHeight - bodyWidth) / 2 + 'px';
                    full.style.left = -(bodyHeight - bodyWidth) / 2 + 'px';
                } else {
                    full.setAttribute('style', '')
                }
            }
        },
        showBar(n, o) {},
    },
    computed: mapGetters(['routerTabs', 'fullScreen', 'showBar']),
}
